// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
export default 'varying vec4 v_output_error_encoded;void main() {gl_FragColor=v_output_error_encoded;}';
